import SelectedApplicant from 'components/applicant/SelectedApplicant';
import ErrorBoundary from 'components/ErrorBoundary';
import {
  addEntries,
  changePage,
  findApplicantsAction,
  findLessonsAction,
  resetTheoryApplicants,
  updateSearchTerms
} from 'ducks/theoryLessons';
import { resetWorkItem } from 'ducks/workItem';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'rebass';
import { bindActionCreators } from 'redux';
import NotFound404 from 'components/NotFound404';
import hasRole from 'util/hasRole';
import { THEORY_BOOKING_APPLICANTS, THEORY_BOOKING_LESSONS } from '../search/SearchType';
import Applicants from './Applicants';
import Lessons from './Lessons';
import { combineCourseToTerms } from '../../util/SearchUtil';

class TheoryLessons extends React.Component {

  searchLessons = (searchTerms) => {
    const lessonType = this.props.lessonType;
    this.props.findLessons(searchTerms, lessonType);
  };
  findApplicantsByLessons = () => {
    const { courseNumber, courseYear, courseUnit } = this.props.searchTerms;
    const lessonIds = !!this.props.lessons ? this.props.lessons.filter(l => l.selected).map(l => l.lessonId) : [];
    const lessonType = this.props.lessonType;
    const terms = { lessonIds, lessonDate: this.props.searchTerms.lessonDate, courseNumber, courseUnit, courseYear };
    this.props.findApplicants(terms, lessonType);
  };
  save = (payload) => {
    Object.assign(payload, { lessonDate: this.props.searchTerms.lessonDate });
    this.props.addEntries(payload);
  };
  selectedApplicantPreviousFn = () => {
    this.findApplicantsByLessons();
    this.props.resetWorkItem();
  };

  componentWillUnmount() {
    this.props.resetTheoryApplicants();
    this.props.resetWorkItem();
  }

  render() {

    const {
      applicants,
      changePage,
      lessons,
      lessonType,
      loading,
      loggedUser,
      currentCourse,
      searchTerms,
      updateSearchTerms,
      resetTheoryApplicants,
      selectedApplicant,
      workItemLoading,
      workItemError,
      showProRequirements,
      page
    } = this.props;

    const isAllowed = hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA']);

    if (isAllowed) {
      return (
        <Container
          mb={!selectedApplicant.applicant ? [8, 8, 7] : 0}
          textAlign='center'>
          <ErrorBoundary>
            {page === 'LESSONS' && !selectedApplicant.applicant &&
              <Lessons lessons={lessons}
                loading={loading.lessons}
                loadingApplicants={loading.applicants}
                lessonType={lessonType}
                nextFn={() => this.findApplicantsByLessons()}
                nextDisabled={!lessons || lessons.filter(l => l.selected).length === 0}
                updateSearchTerms={updateSearchTerms}
                searchType={THEORY_BOOKING_LESSONS}
                searchFn={this.searchLessons}
                showProColumns={showProRequirements}
                currentCourse={currentCourse}
                searchTerms={searchTerms} />
            }
            {page === 'APPLICANTS' && !selectedApplicant.applicant &&
              <Applicants applicants={applicants}
                loadingApplicants={loading.applicants}
                loadingSaving={loading.saving || selectedApplicant.loading}
                searchType={THEORY_BOOKING_APPLICANTS}
                selectedLessons={lessons && lessons.filter(l => l.selected)}
                updateApplicantFilters={this.updateApplicantFilters}
                previousFn={() => changePage('LESSONS') && resetTheoryApplicants()}
                nextFn={this.save}
                currentCourse={currentCourse}
              />
            }
            {!!selectedApplicant.applicant &&
              <SelectedApplicant
                {...selectedApplicant}
                error={workItemError}
                loading={workItemLoading}
                previousFn={this.selectedApplicantPreviousFn} />
            }
          </ErrorBoundary>
        </Container>
      );
    } else {
      return <NotFound404 message={!isAllowed && 'app.missing_perm'} />;
    }
  }
}

TheoryLessons.propTypes = {
  addEntries: PropTypes.func,
  applicants: PropTypes.array,
  error: PropTypes.object,
  lessons: PropTypes.array,
  loading: PropTypes.object,
  loggedUser: PropTypes.object,
  currentCourse: PropTypes.object,
  findLessons: PropTypes.func,
  resetTheoryApplicants: PropTypes.func,
  resetWorkItem: PropTypes.func,
  page: PropTypes.string,
  searchTerms: PropTypes.object,
  selectedApplicant: PropTypes.object,
  showProRequirements: PropTypes.bool,
  workItemLoading: PropTypes.bool,
  workItemError: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
  return {
    applicants: state.theoryLessons.applicants,
    error: state.theoryLessons.error,
    lessons: state.theoryLessons.lessons,
    loading: state.theoryLessons.loading,
    loggedUser: state.userState.user,
    currentCourse: state.userState.currentCourse,
    page: state.theoryLessons.page,
    searchTerms: combineCourseToTerms(state.theoryLessons.searchTerms, state.userState.currentCourse),
    selectedApplicant: state.workItem.selectedApplicant,
    workItemLoading: state.workItem.loading,
    workItemError: state.workItem.error,
    showProRequirements: state.userState.courseData.proCourse,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  addEntries: (payload) => addEntries(payload),
  findLessons: (searchTerms, lessonType) => findLessonsAction(searchTerms, lessonType),
  findApplicants: (searchTerms, lessonType) => findApplicantsAction(searchTerms, lessonType),
  updateSearchTerms: (searchTerms) => updateSearchTerms(searchTerms),
  resetTheoryApplicants: () => resetTheoryApplicants(),
  resetWorkItem: () => resetWorkItem(),
  changePage: (page) => changePage(page),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TheoryLessons);



// WEBPACK FOOTER //
// ./src/containers/theory/index.js